// The picker speaks calendar days; the ordning is open from the start of its first day to the end
// of its last, so a system valid "until 31 December" still admits an application that morning.
// The start is pinned to UTC midnight: the notice's cbc:StartDate is formatted at UTC, so a local
// Oslo midnight would announce the day before the one the buyer picked.
export const startOfUtcDay = (date: string) => `${date}T00:00:00.000Z`;

export const endOfDay = (date: string) => new Date(`${date}T23:59:59.999`).toISOString();
